import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { usePro } from "../contexts/ProContext";

export default function Success() {
  const { refresh } = usePro();
  const [message, setMessage] = useState("Refreshing your subscription status...");
  const [busy, setBusy] = useState(true);

  async function syncStatus() {
    setBusy(true);

    try {
      await refresh();
      setMessage(
        "Payment received. If your backend webhook has completed, Pro should now be visible on your account."
      );
    } catch (error) {
      setMessage(
        error?.message ||
          "Payment succeeded, but the subscription status could not be refreshed yet."
      );
    } finally {
      setBusy(false);
    }
  }

  useEffect(() => {
    syncStatus().catch(() => {});
  }, [refresh]);

  return (
    <div style={{ maxWidth: 720, margin: "0 auto", color: "#f1e7d2" }}>
      <div
        style={{
          padding: 24,
          borderRadius: 22,
          background: "linear-gradient(180deg, #121212, #090909)",
          border: "1px solid rgba(255,255,255,0.08)",
          boxShadow: "0 24px 50px rgba(0,0,0,0.28)",
        }}
      >
        <h1 style={{ margin: 0, color: "#fff7df" }}>Payment successful</h1>
        <p style={{ marginTop: 12, color: "#d9ccb2", lineHeight: 1.6 }}>
          {message}
        </p>
        <div style={{ display: "flex", gap: 10, flexWrap: "wrap", marginTop: 18 }}>
          <button
            type="button"
            onClick={syncStatus}
            disabled={busy}
            style={{
              minHeight: 46,
              padding: "0 16px",
              borderRadius: 12,
              border: 0,
              fontWeight: 900,
              background: "linear-gradient(180deg, #f2b84d, #da8b26)",
              color: "#1a1204",
            }}
          >
            Refresh again
          </button>
          <Link
            to="/play"
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              minHeight: 46,
              padding: "0 16px",
              borderRadius: 12,
              textDecoration: "none",
              background: "rgba(255,255,255,0.08)",
              color: "#f5ecd8",
              fontWeight: 900,
            }}
          >
            Go to training
          </Link>
        </div>
      </div>
    </div>
  );
}
